import React, {useState} from 'react';

import {BlogPageResult} from '../../../../server/routes/blog.js'

interface BlogProps {
    server: string;
    pageData: unknown;
}

export default function Blog({server, pageData}: BlogProps) {

    const typedPageData = pageData as BlogPageResult;
	let [data, setData] = useState(typedPageData);

	return (
        <>
            <div dangerouslySetInnerHTML={{__html:data.html}} />
        </>
	)
}
